import React from "react";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import { useAppContext } from "../../../../../../lib/appContext";
import { START_STEP, START_STEP_NEXT_BUTTON } from "../constants/testIds";

export interface StartStepProps {
  onContinue: () => void;
}

export const StartStep: React.FC<StartStepProps> = ({ onContinue }) => {
  const formatMessage = useFormatMessage();
  const { businessUnitConfig } = useAppContext();
  return (
    <Grid container={true} direction="column" spacing={16} data-testid={START_STEP}>
      <Grid item={true}>
        <Typography variant="body1" component="h3">
          {formatMessage("reviews.reviewForm.invite", {
            businessName: businessUnitConfig.name
          })}
        </Typography>
      </Grid>
      <Grid item={true}>
        <Button
          color="primary"
          variant="outlined"
          onClick={onContinue}
          data-testid={START_STEP_NEXT_BUTTON}
        >
          {formatMessage("reviews.reviewForm.openForm")}
        </Button>
      </Grid>
    </Grid>
  );
};
